import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SettingsTable } from './components';
import { Wrapper } from './styles';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const NotificationsSettings: FC = () => {
  const { t } = useTranslation();
  const { isExpiredSoon, isBlocked } = useSubscription();

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <h1>{t('clinicsConfiguration.aside_menu.notifications_settings')}</h1>
      <SettingsTable />
    </Wrapper>
  );
};

export default NotificationsSettings;
